class MobileDock extends HTMLElement {
  constructor() {
    super();

    new theme.initWhenVisible(this.init.bind(this));
  }

  get section() {
    return this._section = this._section || this.closest('.mobile-dock-section');
  }

  init() {
    this.detectForHeader();
    this.detectForFooter();
    setTimeout(this.setHeight.bind(this));
    document.addEventListener('matchSmall', this.setHeight.bind(this));
    
    // Initialize Zendesk handling
    this.initZendeskChat();
  }

  initZendeskChat() {
    const chatButton = this.querySelector('[data-action="open-zendesk"]');
    if (!chatButton) return;

    // Immediately hide Zendesk widget before it loads
    window.zESettings = {
      webWidget: {
        launcher: {
          mobile: {
            hide: true
          }
        }
      }
    };

    // Wait for Zendesk to load
    const checkZendesk = setInterval(() => {
      if (window.zE) {
        // Set the theme color and initial settings
        window.zE('webWidget', 'updateSettings', {
          webWidget: {
            color: {
              theme: '#2b6eb5'
            },
            launcher: {
              mobile: {
                hide: true
              }
            }
          }
        });

        // Force hide widget immediately
        window.zE('webWidget', 'hide');
        
        // Setup mobile-specific behavior
        const mobileQuery = window.matchMedia('(max-width: 767px)');
        
        const updateZendeskVisibility = (e) => {
          if (e.matches) {
            // On mobile: hide the launcher
            window.zE('webWidget', 'updateSettings', {
              launcher: {
                mobile: {
                  hide: true
                }
              }
            });
            window.zE('webWidget', 'hide');
          } else {
            // On desktop: show the default launcher
            window.zE('webWidget', 'updateSettings', {
              launcher: {
                mobile: {
                  hide: false
                }
              }
            });
            window.zE('webWidget', 'show');
          }
        };
        
        // Run immediately and add listener for screen size changes
        updateZendeskVisibility(mobileQuery);
        mobileQuery.addListener(updateZendeskVisibility);

        // Add click handler for the mobile dock button
        chatButton.addEventListener('click', () => {
          window.zE('webWidget', 'open');
          window.zE('webWidget', 'show');
        });

        // Listen for widget close event
        window.zE('webWidget:on', 'close', () => {
          if (mobileQuery.matches) {
            window.zE('webWidget', 'hide');
            window.zE('webWidget', 'updateSettings', {
              launcher: {
                mobile: {
                  hide: true
                }
              }
            });
          }
        });
        
        clearInterval(checkZendesk);
      }
    }, 100);

    // Clear interval after 10 seconds to prevent infinite checking
    setTimeout(() => clearInterval(checkZendesk), 10000);
  }

  detectForHeader() {
    const header = document.querySelector('.header-section');
    if (header === null) {
      this.section.classList.add('active');
      return;
    }
    
    if (!header.classList.contains('header-sticky')) {
      this.scrollY  = parseInt(header.getBoundingClientRect().bottom);
      window.addEventListener('scroll', theme.utils.throttle(this.onScrollForHeader.bind(this)), false);
    }
  }

  onScrollForHeader() {
    if (window.scrollY >= this.scrollY) {
      this.section.classList.add('active');
    }
    else {
      this.section.classList.remove('active');
    }
  }

  detectForFooter() {
    const footer = document.querySelector('.footer-copyright');
    if (footer === null) return;

    window.addEventListener('scroll', theme.utils.throttle(this.onScrollForFooter.bind(this)), false);
  }

  onScrollForFooter() {
    if (!theme.config.mqlSmall) return;
    
    const scrolledTo = window.scrollY + window.innerHeight;
    const threshold = this.offsetHeight;
    const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
    this.classList.toggle('active', isReachBottom);
  }

  setHeight() {
    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
  }
}
customElements.define('mobile-dock', MobileDock);
